import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./CentralMonitoringScreen.scss";
import "./FooterStyle.scss";
import location from "../../assets/images/location.png";
import list from "../../assets/images/list.svg";
import {
  tabs,
  useAutoRefresh,
  handleStatusClick,
  handleKeyDown,
  focusFirstTab,
} from "../../utils/centralMonitoringUtils.js";

const CentralMonitoringScreen = () => {
  const [activeTab, setActiveTab] = useState("mapView");
  const tabRefs = useRef([]);
  const { dashboardData, loading } = useSelector(
    (state) => state.CentralMonitoringScreenReducer
  );
  const { markerData, loadError, isLoaded } = useSelector(
    (state) => state.buildingData
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useAutoRefresh(dispatch);

  useEffect(() => {
    focusFirstTab(tabRefs);
  }, []);

  return (
    <div className="centralmointor_wrapper main_ele_wrapper">
      <div className="main_heading">
        <h1 id="heading-title" data-testid="Dashboard">
          Dashboard
        </h1>
      </div>

      <div className="inner_wrapper">
        <div className="menu_bar tabMenu_bar viewTab">
          <ul role="tablist">
            {tabs.map((tab, index) => (
              <li key={tab.id} role="none">
                <button
                  id={`tab-${tab.id}`}
                  role="tab"
                  ref={(el) => (tabRefs.current[index] = el)}
                  className={activeTab === tab.id ? "active" : ""}
                  tabIndex={activeTab === tab.id ? 0 : -1}
                  onClick={() => setActiveTab(tab.id)}
                  onKeyDown={(e) =>
                    handleKeyDown(e, index, tabs, setActiveTab, tabRefs)
                  }
                >
                  <img
                    src={tab.id === "mapView" ? location : list}
                    alt=""
                  />
                  <span style={{ marginLeft: 8 }}>{tab.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        className={`${
          activeTab === "listView"
            ? "dashboard_list_wrapper"
            : "dashboard_map_wrapper"
        }`}
      >
        {tabs.map((tab) => (
          <div
            key={tab.id}
            id={`tabpanel-${tab.id}`}
            role="tabpanel"
            aria-labelledby={`tab-${tab.id}`}
            hidden={activeTab !== tab.id}
            tabIndex={-1}
            className="gsdeetails_wrapper"
          >
            {activeTab === "mapView" && tab.id === "mapView" && (
              <tab.Component
                customClass="dashboard-custom-map"
                zoom={4}
                markerData={markerData}
                loadError={loadError}
                isLoaded={isLoaded}
                type="screen"
                markerList={dashboardData}
                onMarkerClick={(markerId) =>
                  handleStatusClick(markerId, dispatch, navigate)
                }
              />
            )}
            {activeTab === "listView" && tab.id === "listView" && (
              <tab.Component
                dashboardData={dashboardData}
                loading={loading}
                className="dashboard_list_wrapper"
              />
            )}
          </div>
        ))}

        {activeTab === "mapView" && (<div
          className="footer_wrapper_dashboard"
          style={{ justifyContent: "center" }}
        >
          <ul className="centerMenu">
            <li>
              <button className="strobe-Button" tabIndex={-1} aria-hidden></button>
              <span>Secure</span>
            </li>
            <li>
              <button className="Push-Button" tabIndex={-1} aria-hidden></button>
              <span>Lockdown</span>
            </li>
            <li>
              <button className="Speaker-Button" tabIndex={-1} aria-hidden></button>
              <span>Drill Mode</span>
            </li>
            <li>
              <button className="Camera-Button" tabIndex={-1} aria-hidden></button>
              <span>Test Mode</span>
            </li>
            <li>
              <button className="Critical-Health" tabIndex={-1} aria-hidden></button>
              <span>Critical</span>
            </li>
          </ul>
        </div>)}
      </div>
    </div>
  );
};

export default CentralMonitoringScreen;
